import isCustomizationBusiness from "@/funcs/isCustomizationBusiness";

export default function () {
  return (
    Number(window.localStorage["erpType"] || 0) === 0 &&
    !isCustomizationBusiness("64539104")
  );
}
